import React, { useState } from "react";
import LayoutDashboard from "layouts/layout-dashboard-collapse";
import { Button } from "react-bootstrap";
import ProductTable from "./components/ProductTable";
import ProductModal from "./components/ProductModal";
import CategoryModal from "./components/CategoryModal";
// import SearchInput from "./components/SearchInput";
import Swal from "sweetalert2";
import { CategoryProvider, useCategory } from "../context/CategoryContext";
import { useCanvasHandler } from "hooks/useCanvasHandler";
import CreatePage from "./components/create-page";
import { deleteRequest } from "services/api";
import { useMenu } from "./MenuContext";
import CreatePageMenu from "./components/create-page-menu";
import CreatePageAddStock from "./components/create-page-add";
import BulkUpdateTax from "./components/BulkUpdateTax";
import CreatePageReduceStock from "./components/create-page-reduce";
import { useSupplier } from "../Supplier/SupplierContext";
import DetailHistory from "./components/detail-history";
import { StockHistoryProvider } from "./StockHistoryContext";

const POS_Products = () => {
  const {
    menus,
    Pagination,
    refetchMenu,
    handleSearch,
    filterOptions,
    handleFilterByCategory,
  } = useMenu();
  // const [categories, setCategories] = useState(dummyCategories);
  const { categories, refetch } = useCategory();
  const { suppliers } = useSupplier();
  const [showProductModal, setShowProductModal] = useState(false);
  const [showCategoryModal, setShowCategoryModal] = useState(false);
  const [editProduct, setEditProduct] = useState(null);

  const {
    handleError,
    showCanvasHandler,
    handleSuccessToast,
  } = useCanvasHandler();

  // ➕ Tambah Kategori
  const handleCreate = (e) => {
    e.preventDefault();
    showCanvasHandler(
      "Create Category",
      <CreatePage
        // onSuccess={handleSuccess}
        onSuccess={() => {
          // handleSuccess(true, "Agent created successfully");
          handleSuccessToast(true, "Category createing");
          refetch();
        }}
        onError={handleError}
      />
    );
  };

  const handleCreateMenu = (e) => {
    e.preventDefault();
    showCanvasHandler(
      "Create",
      <CategoryProvider>
        <CreatePageMenu
          // onSuccess={handleSuccess}
          onSuccess={() => {
            // handleSuccess(true, "Agent created successfully");
            handleSuccessToast(true, "Data createing");
            refetchMenu();
          }}
          onError={handleError}
        />
      </CategoryProvider>
    );
  };

  const handleUpdate = (e, data) => {
    e.preventDefault();
    showCanvasHandler(
      "Update Category",
      <CreatePage
        initialData={data}
        onSuccess={() => {
          handleSuccessToast(true, "Category updateding");
          refetch();
        }}
        onError={handleError}
      />
    );
  };

  const handleUpdateMenu = (e, data) => {
    e.preventDefault();
    showCanvasHandler(
      "Update Menu",
      <CategoryProvider>
        <CreatePageMenu
          initialData={data}
          onSuccess={() => {
            handleSuccessToast(true, "Data updateding");
            refetchMenu();
          }}
          onError={handleError}
        />
      </CategoryProvider>
    );
  };

  const handleDelete = async (id) => {
    Swal.fire({
      title: "Apakah Anda yakin?",
      text: "Anda tidak akan dapat mengembalikan ini!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Ya, hapus!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        // Handle delete action
        const response = await deleteRequest(`/category/${id}`);

        if (response.success) {
          handleSuccessToast(true, "Data deleted successfully");
          refetchMenu();
        }
      }
    });
  };

  const handleDeleteMenu = async (id) => {
    Swal.fire({
      title: "Apakah Anda yakin?",
      text: "Anda tidak akan dapat mengembalikan ini!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Ya, hapus!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        // Handle delete action
        const response = await deleteRequest(`/menu/${id}`);

        if (response.success) {
          handleSuccessToast(true, "Data deleted successfully");
          refetch();
        }
      }
    });
  };

  const handleAddStock = (e, data) => {
    e.preventDefault();
    showCanvasHandler(
      "Add Stock",
      <CreatePageAddStock
        initialData={data} // menu yang ditambah stoknya
        onSuccess={() => {
          handleSuccessToast(true, "Stock added successfully");
          refetchMenu();
        }}
        onError={handleError}
        suppliers={suppliers}
      />
    );
  };

  // const handleAddStockV1 = (e, data) => {
  //   e.preventDefault();

  //   showCanvasHandler(
  //     "Add Stock",
  //     <CreatePageAddStock
  //       initialData={data}
  //       onSuccess={() => {
  //         handleSuccessToast(true, "Data createing");
  //         refetchMenu();
  //       }}
  //       onError={handleError}
  //     />
  //   );
  // };
  
  const handleReduceStock = (e, data) => {
    e.preventDefault();

    showCanvasHandler(
      "Reduce Stock",
      <CreatePageReduceStock
        initialData={data}
        onSuccess={() => {
          handleSuccessToast(true, "Data createing");
          refetchMenu();
        }}
        onError={handleError}
        suppliers={suppliers}
      />
    );
  };

  // detail history
  const handleDetailHistory = (e, data) => {
    e.preventDefault();
    showCanvasHandler(
      "Detail History",
      <StockHistoryProvider>
        <DetailHistory
          initialData={data}
          onSuccess={() => {
            handleSuccessToast(true, "Data createing");
            refetchMenu();
          }}
          onError={handleError}
        />
      </StockHistoryProvider>,
      "fullscreen-canvas"
    );
  };

  const handleBulkUpdateTax = (e) => {
    e.preventDefault();
    showCanvasHandler(
      "Bulk Update Tax",
      <CategoryProvider>
        <BulkUpdateTax
          onSuccess={() => {
            handleSuccessToast(true, "Tax updated successfully");
            refetchMenu();
          }}
          onError={handleError}
        />
      </CategoryProvider>
    );
  };

  return (
    <LayoutDashboard>
      <div className="container-fluid mt-4">
        <div className="d-flex justify-content-between mb-3">
          {/* 🔍 Search Input */}
          {/* <SearchInput search={search} setSearch={setSearch} /> */}
          <SearchInput
            handleSearch={handleSearch}
            filterOptions={filterOptions}
          />

          {/* filter by category */}
          <div>
            {/* <select
              className="form-select"
              onChange={(e) => handleSearch(e, "category")}
              defaultValue={filterOptions.category}
            > */}
            <select
              className="form-select"
              value={filterOptions.filters?.["categories.id"] || ""}
              onChange={(e) => handleFilterByCategory(e.target.value)}
            >
              <option value="">All Categories</option>
              {categories.map((category) => (
                <option key={category.id} value={category.id}>
                  {category.name}
                </option>
              ))}
            </select>
          </div>

          {/* 🛠 Manage Category & Add Product */}
          <div className="ms-2 d-flex gap-2">
            <Button
              variant="outline-primary"
              onClick={handleBulkUpdateTax}
            >
              Bulk Update Tax
            </Button>
            <Button
              variant="secondary"
              onClick={() => setShowCategoryModal(true)}
            >
              Manage Categories
            </Button>
            <Button variant="primary" onClick={handleCreateMenu}>
              + Add Product
            </Button>
          </div>
        </div>

        {/* 📋 Daftar Produk */}
        <ProductTable
          products={menus}
          onEdit={handleUpdateMenu}
          // onDelete={handleDeleteProduct}
          Pagination={Pagination}
          onDelete={handleDeleteMenu}
          handleAddStock={handleAddStock}
          handleReduceStock={handleReduceStock}
          handleDetailHistory={handleDetailHistory}
        />

        {/* 🛒 Modal Tambah/Edit Produk */}
        <ProductModal
          show={showProductModal}
          onHide={() => {
            setShowProductModal(false);
            setEditProduct(null);
          }}
          // onSave={handleSaveProduct}
          product={editProduct}
          categories={categories}
        />

        {/* 🏷️ Modal Kelola Kategori */}
        <CategoryModal
          show={showCategoryModal}
          onHide={() => setShowCategoryModal(false)}
          categories={categories}
          // onAddCategory={handleAddCategory}
          handleCreate={handleCreate}
          handleUpdate={handleUpdate}
          handleDelete={handleDelete}
          // onDeleteCategory={handleDeleteCategory}
        />
      </div>
    </LayoutDashboard>
  );
};

export default POS_Products;

const SearchInput = ({ handleSearch, filterOptions }) => {
  // const [search, setSearch] = useState("");
  const [search, setSearch] = useState(filterOptions.search || "");

  return (
    <div className="input-icon">
      <input
        type="text"
        className="form-control"
        placeholder="Search..."
        value={search}
        // onChange={(e) => setSearch(e.target.value)}
        onChange={(e) => setSearch(e.target.value)}
        onKeyDown={handleSearch}
      />
      <span className="input-icon-addon">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="icon icon-tabler icon-tabler-search"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          strokeWidth="2"
          stroke="currentColor"
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
          <circle cx="10" cy="10" r="7" />
          <line x1="21" y1="21" x2="15" y2="15" />
        </svg>
      </span>
    </div>
  );
};
